// extracted by mini-css-extract-plugin
module.exports = {"slateImageComponent":"styles_slateImageComponent__a_3YZ"};